import Home from '@/views/Home'
import Product from '@/views/basic/Product'
import Factory from '@/views/basic/Factory'
import User from '@/views/basic/User'
import KeyLicence from '@/views/KeyLicence'
import KeyFactory from '@/views/KeyFactory'


export default {
    Home,
    Product,
    Factory,
    User,
    KeyLicence,
    KeyFactory
}


// WEBPACK FOOTER //
// ./src/views/index.js